import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: () => import("./views/Main.vue"),
      children: [
        {
          path: "",
          name: 'home',
          component: () => import("./views/Home.vue")
        },
        {
          path: "/menu",
          name: "menu",
          component: () => import("./views/Menu.vue")
        },
        {
          path: "/form",
          name: "form",
          component: () => import("./views/Form.vue")
        },
        {
          path: "/addarticle",
          name: "addarticle",
          component: () => import("./views/AddArticle.vue")
        },
        {
          path: "/upload",
          name: "upload",
          component: () => import("./views/Upload.vue")
        },
        {
          path: "/upload2",
          name: "upload2",
          component: () => import("./views/Upload2.vue")
        },
        {
          path: "/role",
          name: "role",
          component: () => import("./views/sys/Role.vue")
        },
        {
          path: "/manager",
          name: "manager",
          component: () => import("./views/sys/Manager.vue")
        },
        {
          path: "/navigation",
          name: "navigation",
          component: () => import("./views/sys/Navigation.vue")
        },
        {
          path: "/siteconfig",
          name: "siteconfig",
          component: () => import("./views/sys/SiteConfig.vue")
        },
        {
          path:"/link",
          name:"link",
          component:()=>import("./views/base/Link.vue")
        },
        {
          path:"/banner",
          name:"banner",
          component:()=>import("./views/base/Banner.vue")
        },
        {
          path:"/info",
          name:"info",
          component:()=>import("./views/art/Info.vue")
        },
        {
          path:"/strategy",
          name:"strategy",
          component:()=>import("./views/art/Strategy.vue")
        },
        {
          path:"/abroad",
          name:"abroad",
          component:()=>import("./views/above/Abroad.vue")
        },
        {
          path:"/downloadrecord",
          name:"downloadrecord",
          component:()=>import("./views/above/DownloadRecord.vue")
        },
        {
          path:"/downloaduser",
          name:"downloaduser",
          component:()=>import("./views/above/DownloadUser.vue")
        },
        {
          path:"/graduate",
          name:"graduate",
          component:()=>import("./views/above/Graduate.vue")
        },
        {
          path:"/college",
          name:"college",
          component:()=>import("./views/sch/College.vue")
        },
        {
          path:"/major",
          name:"major",
          component:()=>import("./views/sch/Major.vue")
        },
        {
          path:"/service",
          name:"service",
          component:()=>import("./views/sch/Service.vue")
        },
        {
          path:'/school',
          name:"school",
          component:()=>import("./views/sch/School.vue")
        },
        {
          path:'/image',
          name:"image",
          component:()=>import("./views/sch/Image.vue")
        },
        {
          path:"/video",
          name:"video",
          component:()=>import("./views/video/Video.vue")
        },
        {
          path:"/datum",
          name:"datum",
          component:()=>import("./views/video/Datum.vue")
        },
        {
          path:"/case",
          name:"name",
          component:()=>import("./views/video/Case.vue")
        },
        {
          path:"/bigevent",
          name:"bigevent",
          component:()=>import("./views/video/Bigevent.vue")
        },
        {
          path:"/question",
          name:"question",
          component:()=>import("./views/video/Question.vue")
        },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
  ]
});
